class RentalCalendar extends HTMLElement {
  constructor() {
    super();
    this.initialize();
  }

  initialize() {
    this.quantity = $('[data-product-quantity]');
    this.price = $('[data-product-price]');
    this.priceWrapper = $('[data-product-price-wrapper]');
    this.dateProperty = $('[data-date-property]');
    this.dateStartProperty = $('[data-date-start-property]');
    this.dateEndProperty = $('[data-date-end-property]');
    this.id = this.getAttribute('data-id')
    
    const datepicker = ('#datepicker');

    fetch(`https://api.bookthatapp.com/v1/blocks?external_id=${this.id}&start=2022-03-21T00:00&finish=2023-01-02T00:00`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6NjAyMTYsInNob3AiOiJwYWxldHRlLXN1cHBseSJ9.L3-ckRH6wtaJhUwzT4vlfI6K1WnCY2De76M3Bc6mOi0`
      }
    })
      .then(res => res.json())
      .then(res => {
        this.datepicker = datepicker.datepicker({
          defaultDate: null,
          beforeShowDay: (date) => {
            const sameDay = res.blocks && res.blocks.find(block => moment.utc(block.date).isSame(moment.utc(date), 'day'));
            let isAvailable = false;
            if(sameDay && sameDay['available_slot_count'] >= 1) {
              isAvailable = true;
            }
            var className = this.shouldDateBeSelected(date) && isAvailable ? "active" : "";
            return [isAvailable, className];
          },
          minDate: 0
        });
        $('.ui-state-hover').removeClass('ui-state-hover')
        this.datepicker.on('change', function() {
          const date = this.value;
          handleChange(date);
        })
      })
      .catch(e => {
        console.error(e)
      })


    const handleChange = this.handleChange.bind(this);
  }

  handleChange(date) {
    const startDate = this.startDate;
    const endDate = this.endDate;
    const dateTime = moment(this.convertStringToJSDate(date));

    if(startDate && dateTime.isSame(startDate)) {
      this.clearEndDate(date);
    } else if (endDate && dateTime.isSame(endDate)) {
      this.clearStartDate();
      this.setStartDate(date)
    } else if(startDate && dateTime.isBefore(startDate)) {
      this.setStartDate(date);
    } else if (endDate && dateTime.isAfter(endDate)) {
      this.setEndDate(date);
    } else if (startDate && !endDate) {
      this.setEndDate(date);
    } else {
      this.setStartDate(date);
    }

    this.updateProductForm();
  }

  updateProductForm() {
    const start = this.startDate;
    const end = this.endDate;
    let quantity = 0;
    let dateString = '';

    if(start && !end) {
      quantity = 1;
      dateString = start.format('D MMM, YYYY');
    }

    if(start && end) {
      quantity = Math.abs(start.diff(end, 'days') - 1)
      dateString = `${start.format('D MMM')} - ${end.format('D MMM, YYYY')}`
    }

    this.quantity.val(quantity);
    
    // SET PRICE
    const price = this.price.attr('data-price');
    this.price.text(`$${(price / 100) * quantity}`);
    this.priceWrapper.removeClass('visually-hidden');
    this.dateProperty.val(dateString);
    this.dateStartProperty.val(start);
    this.dateEndProperty.val(end);
  }

  setStartDate(value, keepEndDate) {
    keepEndDate = keepEndDate || false;
    this.clearEndDate();
    
    this.startDate = moment(this.convertStringToJSDate(value));
    // this.sendDatesToInputs();
    // if(this.disableOutsideDates) {
    //   this.$datepicker.datepicker("option", "minDate", value);
    // }
  }
  
  setEndDate(value) {
    this.endDate = moment(this.convertStringToJSDate(value));
    // this.sendDatesToInputs();
    // if(this.disableOutsideDates) {
    //   this.$datepicker.datepicker("option", "maxDate", value);
    // }
  }

  clearEndDate() {
    this.endDate = null;
    // if(this.disableOutsideDates) {
    //   this.$datepicker.datepicker("option", "maxDate", "");
    // }
  }
  
  clearStartDate() {
    this.startDate = null;
    // if(this.disableOutsideDates) {
    //   this.$datepicker.datepicker("option", "minDate", "");
    // }
  }

  shouldDateBeSelected(date) {
    var startDate = this.startDate;
    var endDate = this.endDate;
    if(!moment.isMoment(date)) {
      date = moment(date);
    }

    if(startDate && endDate && date.isSameOrAfter(startDate) && date.isSameOrBefore(endDate)) {
      return true;
    } else if (startDate && date.isSame(startDate) || endDate && date.isSame(endDate)) {
      return true;
    } else {
      return false;
    }
  }

  convertStringToJSDate(date, asMoment) {
    asMoment = asMoment || false;
    if(date) {
      var split = date.split("/");
      var day = split[1];
      var month = split[0] - 1;
      var year = split[2];
      if(asMoment) {
        return moment(new Date(year, month, day));
      } else {
        return new Date(year, month, day);
      }
    } else {
      return null;
    }
  }
}

customElements.define('rental-calendar', RentalCalendar);